// Demo mode persistence + flag-aware link helpers.
//
// Demo mode is ON when:
//   1. URL contains ?demo=1, OR
//   2. sessionStorage has it set (sticky from a prior ?demo=1 hit), OR
//   3. The current user is logged in as ADMIN (admin always sees demo tools)
// Use ?demo=0 to turn it off explicitly.

import { TOKEN_KEY } from "./api";

const KEY = "arp_demo_mode";

function isAdminLoggedIn() {
    if (typeof window === "undefined") return false;
    try {
        const token = localStorage.getItem(TOKEN_KEY);
        if (!token) return false;
        const payload = JSON.parse(atob(token.split(".")[1]));
        return payload?.role === "admin";
    } catch {
        return false;
    }
}

function syncFromUrl() {
    if (typeof window === "undefined") return;
    const params = new URLSearchParams(window.location.search);
    const v = params.get("demo");
    if (v === "1") sessionStorage.setItem(KEY, "1");
    else if (v === "0") sessionStorage.removeItem(KEY);
}

export function isDemoMode() {
    if (typeof window === "undefined") return false;
    syncFromUrl();
    const params = new URLSearchParams(window.location.search);
    if (params.get("demo") === "0") return false;
    if (params.get("demo") === "1") return true;
    if (sessionStorage.getItem(KEY) === "1") return true;
    return isAdminLoggedIn();
}

export function setDemoMode(on) {
    if (typeof window === "undefined") return;
    if (on) sessionStorage.setItem(KEY, "1");
    else sessionStorage.removeItem(KEY);
}

export function reviewPath() {
    return withDemoFlag("/review");
}

// Generic: appends ?demo=1 (and ?agent=slug) to any internal path if currently in demo mode.
export function withDemoFlag(path) {
    if (typeof window === "undefined") return path;
    const params = new URLSearchParams(window.location.search);
    const agent = params.get("agent");
    const out = new URLSearchParams();
    if (isDemoMode()) out.set("demo", "1");
    if (agent && (path === "/review" || path.startsWith("/review?"))) out.set("agent", agent);
    const qs = out.toString();
    if (path.includes("?")) {
        const [base, existing] = path.split("?");
        const merged = new URLSearchParams(existing);
        if (isDemoMode()) merged.set("demo", "1");
        return `${base}?${merged.toString()}`;
    }
    return qs ? `${path}?${qs}` : path;
}
